import type { TQrDesign } from 'features/generator/services/types'

type ReverseMapping<T extends Record<string, string>> = {
	[K in keyof T as T[K]]: K
}

const reverseObject = <T extends Record<string, string>>(
	obj: T,
): ReverseMapping<T> => {
	// eslint-disable-next-line
	const reversed = {} as any

	for (const key in obj) {
		const value = obj[key]
		reversed[value] = key
	}

	return reversed
}

export const enum GENERATOR_SEARCH_PARAM {
	Id = 'id',
	Target = 'target',
	Edit = 'edit',
}

export type TGeneratorSearchParams = Record<GENERATOR_SEARCH_PARAM, string>

export type TGeneratorStep = 'type' | 'content' | 'design'

export const enum QR_TYPE {
	App = 'app',
	Facebook = 'facebook',
	VCard = 'vCard',
	Images = 'images',
	PlainText = 'plainText',
	BusinessPage = 'businessPage',
	Video = 'video',
	Wifi = 'wifi',
	SocialMedia = 'socialMedia',
	Menu = 'menu',
	Url = 'url',
	Pdf = 'pdf',
}

export const PARAM_TO_QR_TYPE = {
	app: QR_TYPE.App,
	facebook: QR_TYPE.Facebook,
	vcard: QR_TYPE.VCard,
	images: QR_TYPE.Images,
	video: QR_TYPE.Video,
	wifi: QR_TYPE.Wifi,
	'social-media': QR_TYPE.SocialMedia,
	menu: QR_TYPE.Menu,
	url: QR_TYPE.Url,
	'plain-text': QR_TYPE.PlainText,
	'business-page': QR_TYPE.BusinessPage,
	pdf: QR_TYPE.Pdf,
} satisfies Record<string, QR_TYPE>

export type TQrTypeParam = keyof typeof PARAM_TO_QR_TYPE

export const QR_TYPE_TO_PARAM = reverseObject(PARAM_TO_QR_TYPE)

export type TQrContent = { type: QR_TYPE }

export type TContentFormProps = {
	qrId?: string
	qrUri?: string
	qrName?: string
	qrContent?: TQrContent
	qrDesign?: TQrDesign | null
	isChangeTypeMode?: boolean
}
